import React, { createContext, useState } from 'react'

export const PaymentContext = createContext(null)

const PaymentContextProvider = ({ children }) => {
  const [isPaymentOpen, setIsPaymentOpen] = useState(false)

  return (
    <PaymentContext.Provider value={{ isPaymentOpen, setIsPaymentOpen }}>
      {children}
    </PaymentContext.Provider>
  )
}

export default PaymentContextProvider
